import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import "./assets/tailwind.css";
import i18n from "./i18n";

const app = createApp(App);
const pinia = createPinia();

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(reg => {
          console.log('Service worker registered.', reg);
        });
    });
  }

app.use(pinia);
app.use(router);
app.use(i18n);
app.mount("#app");
